import React, { useState, useRef, useEffect, useCallback } from "react";
// import PlanActualsGrid from "./Grids/PlanActualsGridOne";
// import courseData from './mockData.json';
// import ReportsFilter from "./ReportsFilter";
import { styled } from "@mui/material/styles";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AddAttendeesGrid from "./AddAttendeesGrid";
import Modal from '@mui/material/Modal';
// import Year from '../Calendar/Year';

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
    "&.MuiToggleButton-root": {
        lineHeight: 0.75,
        borderRadius: '28px',
        backgroundColor: '#32383E'
    },
    "&.MuiToggleButton-root.Mui-selected": {
        color: 'white',
        background: 'linear-gradient(#57380B, #A06C21)'
    }
}))

const AddAttendees = (props) => {
    const { showAddAttendeeList } = props;
    const [selectedYear, setSelectedYear] = useState();
    const [alignment, setAlignment] = useState("uae");
    const [showAttendeeList, setShowAttendeeList] = useState(showAddAttendeeList);

    const handleToggleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    }

    const handleClose = () => {
        setShowAttendeeList(false);
        // setShowAddAttendeeList(false);
    }

    return (
        <>
            <Modal
                open={showAttendeeList}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="w-full sm:w-12/12 px-28 py-8">
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleToggleChange}
                        aria-label="Request"
                    >
                        <CustomToggleButton value="uae">UAE</CustomToggleButton>
                        <CustomToggleButton value="kuw">KUW</CustomToggleButton>
                        <CustomToggleButton value="mal">MAL</CustomToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className="grid grid-cols-1 gap-16 px-24 pb-8">
                    <div className="flex flex-col mt-24 pt-16 rounded-xl" style={{ backgroundColor: "#8B6392", textAlign: "center" }}>
                        <AddAttendeesGrid showAttendeeList={showAddAttendeeList} handleClose={handleClose} />
                    </div>
                </div>
                {/* <div style={{ borderTop: "1px solid #FFFFFF", margin: "20px 20px" }}></div> */}
            </Modal>
        </>
    )
}

export default AddAttendees;